import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FormModal.module.css';

const courseOptions = [
  'עיצוב ושיקום גבות ושעוות פנים',
  'הרמת ריסים + הרמת גבות',
  'השתלמות הרמת ריסים',
  'קורס טריפל עיצוב גבות + הרמת ריסים וגבות',
  'עדיין לא בטוחה, אשמח שנבין יחד',
];

const experienceOptions = [
  'כן, למדתי כבר כמה תחומים בעבר',
  'כן, למדתי בעבר והאמת שהתאכזבתי גם',
  'לא משהו רשמי, עושה לחברות',
  'אפס נסיון',
];

const availabilityOptions = [
  'כמה שיותר מהר!',
  'בחודש-חודשיים הקרובים',
  'רק מתעניינת בינתיים',
];

const goalOptions = [
  'לפתוח עסק עצמאי ולהתפרנס מזה',
  'להוסיף שירות לעסק קיים',
  'ללמוד בשביל עצמי ולחברות',
  'עדיין לא בטוחה',
];

/* Reusable custom dropdown */
function CustomDropdown({ value, onChange, placeholder, options, openId, setOpenId, id }) {
  const ref = useRef(null);
  const isOpen = openId === id;

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        if (isOpen) setOpenId(null);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [isOpen, setOpenId]);

  return (
    <div className={styles.dropdown} ref={ref}>
      <button
        type="button"
        className={`${styles.dropdownTrigger} ${value ? styles.dropdownHasValue : ''}`}
        onClick={() => setOpenId(isOpen ? null : id)}
      >
        <span>{value || placeholder}</span>
        <svg className={`${styles.dropdownArrow} ${isOpen ? styles.dropdownArrowOpen : ''}`} width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path d="M1 1.5l5 5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          {options.map((option) => (
            <button
              key={option}
              type="button"
              className={`${styles.dropdownItem} ${value === option ? styles.dropdownItemActive : ''}`}
              onClick={() => { onChange(option); setOpenId(null); }}
            >
              {value === option && <span className={styles.dropdownCheck}>✓</span>}
              <span>{option}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function FormModal({ isOpen, onClose, selectedCourse = null }) {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [course, setCourse] = useState(selectedCourse || '');
  const [interest, setInterest] = useState('');
  const [city, setCity] = useState('');
  const [experience, setExperience] = useState('');
  const [availability, setAvailability] = useState('');
  const [goal, setGoal] = useState('');
  const [source, setSource] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (selectedCourse) setCourse(selectedCourse);
  }, [selectedCourse]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    if (isSubmitting) return;

    setIsSubmitting(true);

    const detailedInfo = `
קורס מבוקש: ${course || 'לא צוין'}
---
1. ניסיון בתחום היופי: ${experience || 'לא צוין'}
2. מתי רוצה להתחיל: ${availability || 'לא צוין'}
3. מטרה: ${goal || 'לא צוין'}
4. הערות: ${interest || 'לא צוין'}
5. עיר: ${city || 'לא צוין'}
6. מקור הגעה: ${source || 'לא צוין'}
`.trim();

    const serverData = {
      name: name.trim(),
      phone: phone.replace(/[-\s]/g, ''),
      email: '',
      reason: detailedInfo,
      reciver: 'Romibusiness01@gmail.com',
    };

    try {
      const response = await fetch(
        'https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(serverData),
        }
      );

      if (!response.ok) throw new Error('Server error');

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      navigate('/תודה');
    } catch (err) {
      console.error('Submit error:', err);
      alert('שגיאה בשליחת הטופס, נסי שוב');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.glowTR} />
      <div className={styles.glowBL} />

      <button className={styles.closeBtn} onClick={onClose} aria-label="סגירה">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <path d="M2 2l12 12M14 2L2 14" />
        </svg>
      </button>

      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>כמה פרטים ואנחנו מדברות</h2>
          <div className={styles.divider}>
            <span className={styles.dividerLine} />
            <span className={styles.dividerDot}>✦</span>
            <span className={styles.dividerLine} />
          </div>
          <p className={styles.modalSubtitle}>
            השאירי פרטים בטופס הבא ואחזור אלייך אישית לשיחה קצרה ללא עלות ונבדוק יחד התאמה
          </p>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          {/* Row: שם + טלפון */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="name">איך קוראים לך?</label>
              <input
                id="name"
                className={styles.input}
                type="text"
                placeholder="השם שלך"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="phone">מספר טלפון</label>
              <input
                id="phone"
                className={styles.input}
                type="tel"
                placeholder="050-0000000"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                dir="ltr"
                style={{ textAlign: 'right' }}
              />
            </div>
          </div>

          {/* Dropdown: קורס */}
          <div className={styles.formGroup}>
            <label className={styles.label}>איזה קורס הכי דיבר אלייך?</label>
            <CustomDropdown
              value={course}
              onChange={setCourse}
              placeholder="בחרי קורס"
              options={courseOptions}
              openId={openDropdown}
              setOpenId={setOpenDropdown}
              id="course"
            />
          </div>

          {/* Dropdown: ניסיון */}
          <div className={styles.formGroup}>
            <label className={styles.label}>יש לך ניסיון בתחום היופי?</label>
            <CustomDropdown
              value={experience}
              onChange={setExperience}
              placeholder="בחרי תשובה"
              options={experienceOptions}
              openId={openDropdown}
              setOpenId={setOpenDropdown}
              id="experience"
            />
          </div>

          {/* Dropdown: מתי תרצי להתחיל */}
          <div className={styles.formGroup}>
            <label className={styles.label}>מתי את רוצה להתחיל?</label>
            <CustomDropdown
              value={availability}
              onChange={setAvailability}
              placeholder="בחרי תשובה"
              options={availabilityOptions}
              openId={openDropdown}
              setOpenId={setOpenDropdown}
              id="availability"
            />
          </div>

          {/* Dropdown: מטרה */}
          <div className={styles.formGroup}>
            <label className={styles.label}>מה המטרה שלך?</label>
            <CustomDropdown
              value={goal}
              onChange={setGoal}
              placeholder="בחרי תשובה"
              options={goalOptions}
              openId={openDropdown}
              setOpenId={setOpenDropdown}
              id="goal"
            />
          </div>

          {/* מה מסקרן אותך */}
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="interest">יש משהו שחשוב לך שאדע?</label>
            <textarea
              id="interest"
              className={styles.textarea}
              placeholder="רשמי כאן כל דבר שעולה לך..."
              value={interest}
              onChange={(e) => setInterest(e.target.value)}
              rows={3}
            />
          </div>

          {/* Row: עיר + מקור */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="city">מאיפה את?</label>
              <input
                id="city"
                className={styles.input}
                type="text"
                placeholder="עיר / ישוב"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="source">איך הגעת אליי?</label>
              <select
                id="source"
                className={styles.select}
                value={source}
                onChange={(e) => setSource(e.target.value)}
              >
                <option value="">בחרי אופציה</option>
                <option value="אינסטגרם">אינסטגרם</option>
                <option value="פייסבוק">פייסבוק</option>
                <option value="טיקטוק">טיקטוק</option>
                <option value="חברה המליצה">חברה המליצה</option>
                <option value="חיפוש בגוגל">חיפוש בגוגל</option>
                <option value="אחר">אחר</option>
              </select>
            </div>
          </div>

          <button type="submit" className={styles.submitBtn} disabled={isSubmitting}>
            <span className={styles.submitShine} />
            <span className={styles.submitText}>
              {isSubmitting ? 'שולחת...' : 'שלחי ואני כבר אחזור אלייך'}
            </span>
          </button>
        </form>
      </div>
    </div>
  );
}

export default FormModal;
